import { useContext } from 'react';
import { QuickLinksContext } from './QuickLinksContextProvider';
export default function useQuickLinksContext() {
    return useContext(QuickLinksContext);
}
